const envUrl = process.env.REACT_APP_API_URL;
export const API_URL = envUrl !== undefined ? envUrl : '';